import { CURRENCIESWITHOUTDECIMALS } from '../../../../constants';
import defaults from 'lodash/fp/defaults';

export default function formatCurrencyWithDecimalSplit(locale, value, options = {}) {
  const newOptions = defaults({
    currency: 'USD',
    currencyDisplay: 'code',
    style: 'currency',
  }, options);
  const formatter = new Intl.NumberFormat(locale, newOptions);

  function getDecimalSeparator() {
    var n = 1.1;
    n = n.toLocaleString(locale).substring(1, 2);
    return n;
  }
  
  let formatted = formatter.format(value);

  if (CURRENCIESWITHOUTDECIMALS.includes(newOptions.currency)) {
    return {
      number: formatted,
      decimal: '',
    };
  }

  if (formatted.indexOf(getDecimalSeparator()) < 0) {
    return {
      number: formatted,
      decimal: '',
    }
  }

  let ceil = Math.ceil(value);

  if (ceil === value) {
    ceil += 1;
  }

  let floorFormatted = formatter.format(Math.floor(value) + 0.11111111);
  let ceilFormatted = formatter.format(ceil - 0.11111111);

  if (!options.currency) {
    formatted = formatted.replace('USD', '').trim();
    floorFormatted = floorFormatted.replace('USD', '').trim();
    ceilFormatted = ceilFormatted.replace('USD', '').trim();
  }

  if (formatted.length == floorFormatted.length || formatted.length == ceilFormatted.length) {
    let index = locale == 'en' ? formatted.length - 1 : formatted.length;

    while (index > 0
      && (formatted[index] !== floorFormatted[index]
        || formatted[index] !== ceilFormatted[index])) {
      index--;
    }

    return {
      number: formatted.slice(0, index),
      decimal: formatted.slice(index),
    };
  } else {
    let number = formatted.split(getDecimalSeparator());
    let decimal = number[1].indexOf(options.currency) > 1 ? number[1].replace(options.currency, ''):number[1];
    return {
      number: number[0],
      decimal: getDecimalSeparator()+decimal,
    };
  }
}
